import { useState, useContext, useEffect } from "react";
import Menu from "@mui/material/Menu";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { Autocomplete, TextField } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { AuthContext } from "context";
import AuthService from "services/auth-service";
import { jwtDecode } from 'jwt-decode';
import { useMaterialUIController, toggleReloadWallets, setWallet } from "context";

function Settings() {
    const [controller, dispatch] = useMaterialUIController();
    const authContext = useContext(AuthContext);
    const [openMenu, setOpenMenu] = useState(false);
    const { wallets, wallet } = controller;

    useEffect(() => {
        if (wallets.length === 0) {
            toggleReloadWallets(dispatch, Date.now());
        }
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token && wallets.length > 0) {
            const activeWallet = wallets.find(item => item.id === jwtDecode(token)?.active_wallet_id);
            setWallet(dispatch, activeWallet);
        }
    }, [wallets]);
    
    const handleWalletChange = async (event, newValue) => {
        const response = await AuthService.setActiveWallet(newValue.id);
        authContext.login(response.token, false);
        setWallet(dispatch, newValue);
    };
    
    const handleLogOut = async () => {
        authContext.logout();
    };
    
    const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
    
    const handleCloseMenu = () => setOpenMenu(false);

    return (
        <>
            <IconButton size="small" disableRipple color="inherit" sx={navbarIconButton} aria-controls="notification-menu" aria-haspopup="true" variant="contained" onClick={handleOpenMenu}>
                <Icon sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>settings</Icon>
            </IconButton>
            <Menu anchorEl={openMenu} open={Boolean(openMenu)} onClose={handleCloseMenu} sx={{ mt: 2 }}>
                <MDBox>
                    <MDTypography variant="h5">Settings</MDTypography>
                    <MDTypography variant="body2" color="text">
                        Your green wallet settings.
                    </MDTypography>
                </MDBox>
                <Autocomplete
                    options={wallets}
                    getOptionLabel={(option) => option.name}
                    value={wallet}
                    onChange={handleWalletChange}
                    isOptionEqualToValue={(option, value) => option.id === value.id}  
                    fullWidth
                    margin="normal"
                    sx={{ mb: 1, mt: 1 }}
                    renderInput={(params) => (
                        <TextField {...params} label="Wallet" variant="outlined" />
                    )}
                />
                <MDButton sx={{ mb: 1, mt: 1 }} variant="gradient" color="info" fullWidth type="button" onClick={handleLogOut}>
                    Log Out
                </MDButton>
            </Menu>
        </>
    );
}

export default Settings;